export default __webpack_public_path__ + "static/media/pokeball-icon.e27def11.png";